import { PeriodFilter } from './../../models/period-filter.model';
import { HttpParams } from '@angular/common/http';
import { AddPeriodModel, PeriodModel } from './../../models/period.model';

export class FilterPeriods {
  static readonly type = '[Period-State] Filter Periods';
  constructor(public params?: HttpParams, public filter?: PeriodFilter) {}
}

export class AddPeriod {
  static readonly type = '[Period-State] Add Period';
  constructor(public model: AddPeriodModel) {}
}

export class EditPeriod {
  static readonly type = '[Period-State] Edit Period';
  constructor(public model: AddPeriodModel) {}
}

export class RemovePeriod {
  static readonly type = '[Period-State] Remove Period';
  constructor(public modelId: string) {}
}

export class ImportPeriods {
  static readonly type = '[Period-State] Import Periods';
  constructor(public data: string) {}
}
